import React from 'react';
import styled from 'styled-components';

const SwitchElement = styled.div`
  position: relative;
  display: inline-block;
  height: 25px;

  input {
    width: 16px;
    -webkit-appearance: none;
    -webkit-border-radius: 0.25em;
    margin: 0;
    height: 0px;
    font-size: 15px !important;
     
    display: block;
    font-weight: normal !important;
    color: #3F4648;
    border: none;
    border-bottom: 1px solid #ccc;
    padding: 11px 24px !important;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    border-radius: 28px;

    &:focus {
      box-shadow: 0px 0.5px 0px 2.5px #000000;
      border-radius: 11px;
      outline: none;
    }
  }

  label {
    display: block;
    width: 48px;
    height: 24px;
    text-indent: -150%;
    clip: rect(0 0 0 0);
    color: transparent;
    user-select: none;
  }

  label::before,
  label::after {
    content: "";
    display: block;
    position: absolute;
    cursor: pointer;
  }

  label::before {
    width: 100%;
    height: 100%;
    background-color: ${(props) => props.labelBgColor || '#dedede'};
    border-radius: 9999em;
    -webkit-transition: all .25s ease;
    transition: all .25s ease;
  }

  label::after {
    top: 0;
    left: 0px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.45);
    -webkit-transition: all .25s ease;
    transition: all .25s ease;
  }

  input:checked + label::before {
    background-color: ${(props) => props.inputBgColor || '#378B87'};
  }

  input:checked + label::after {
    left: 24px;
  }

  input:focus {
    box-shadow: none;
  }

  input:focus-visible {
    /* remove default focus style */
    outline: none;
    /* custom focus styles */
    box-shadow: 0 0 2px 2px #51a7e8;
  }
`;

const Switch = ({
  id,
  labelBgColor,
  inputBgColor,
  name,
  variant,
  switchRef,
  ...props
}) => (
  <SwitchElement
    labelBgColor={labelBgColor}
    inputBgColor={inputBgColor}
  >
    <input
      id={id}
      name={name}
      ref={switchRef}
      type={variant === 'single' ? 'radio' : 'checkbox'}
      {...props}
    />
    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
    <label htmlFor={id} />
  </SwitchElement>
);

export default Switch;
